export default __webpack_public_path__ + "static/media/question-interview-management.fa5d9df9.svg";